/**
 * Products Category API
 */

import {
  ProductsCategory,
  ProductsCategoryListResponse,
} from '../types/products-category';
import { STRAPI_URL } from './base';

export async function fetchProductCategories(): Promise<ProductsCategory[]> {
  try {
    const searchParams = new URLSearchParams();
    searchParams.append('sort[0]', 'name:asc');

    const url = `${STRAPI_URL}/api/products-categories?${searchParams.toString()}`;
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...(process.env.NEXT_PUBLIC_STRAPI_API_TOKEN && {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
        }),
      },
      next: { revalidate: 300 },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        'Products categories API error:',
        response.status,
        errorText
      );
      return []; // Return empty array as fallback
    }

    const result: ProductsCategoryListResponse = await response.json();
    return result.data;
  } catch (error) {
    console.error('Error fetching product categories:', error);
    return []; // Return empty array as fallback
  }
}
